module.exports = __webpack_public_path__ + "static/business-professionals-ea762f92a525e950985678bd0398d3c0.jpg";